import React, { useEffect } from 'react'
import { StyleSheet, View } from 'react-native'
import {
  Title,
  Space
} from '@sart/components'
import { useContent } from '@sart/content'
import client from '@sart/client'

import { GuruQuestion, GuruThumbsUp } from '@sart/icons'
import { colors  } from '@sart/styles'

export default function ProfilePaymentProcessing(props) {
  const content = useContent();

  const { navigation, route } = props

  useEffect(() => {
    saveCardToken()
  }, [])

  async function saveCardToken(){
    // GET the SAVE-VALIDATED-PAYMENT-CARD product from the catalog
    const refId = route.params?.orderRefId
    const cardToken =route.params?.cardToken
    let tokeniseProducts = await client.callApi('catalog','getTokenizeCardProducts',[client.cache.catalogId])
    const saveProduct = tokeniseProducts.find(
      product => product.productLegacyId === 'SAVE-VALIDATED-PAYMENT-CARD'
    )
    //set up extended data
    const extendedData = {
      validationOrder:{
        orderRefId:refId
      }
    }
    //do transaction
    let order = await client.checkoutCustomerProductNoPayment(saveProduct,extendedData)
    order.cardToken = cardToken
    //console.log('[MATT] order: ' + JSON.stringify(order,null,2))
    navigation.navigate('ProfilePaymentConfirmation', {
      order
    })
    
  }

  return (
    <View style={styles.container}>
      <Space height={24} />
      <GuruThumbsUp width={220} height={181}/>
      <Space height={48} />

      <Title style={styles.title}>
        {content.common.processing}
      </Title>
      
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.srGreen,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  },
  title: {
    color: colors.white,
    fontSize: 24
  },
})

